import React, { useState, useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import {
  Grid,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  styled,
} from "@mui/material";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { fr, enGB } from "date-fns/locale";
import { DatePicker } from "@mui/x-date-pickers";

import PropTypes from "prop-types";

//get DispensingLanguage
const DispensingLanguage = JSON.parse(
  localStorage.getItem("DispensingLanguage"),
);
const lan = localStorage.getItem("LangCode");
const menukey = "patients";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiDialog-paper": {
    minWidth: "80%",
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
          size="large"
        >
          {/* <CloseIcon /> */}
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const AllergiesTab = ({
  open,
  handleClose,
  allergyData,
  handleChangeByTabs,
  handleSubmitByTabs,
  handleRDateChangeByTabs,
  errorAllergiesData,
}) => {
  return (
    <>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
        >
          {DispensingLanguage[lan][menukey]["ALLERGIES ENTRY"]} -{" "}
          {allergyData.id
            ? DispensingLanguage[lan][menukey]["EDIT"]
            : DispensingLanguage[lan][menukey]["ADD"]}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={2}>
              <LocalizationProvider
                dateAdapter={AdapterDateFns}
                adapterLocale={lan === "en_GB" ? enGB : fr}
              >
                <DatePicker
                  label={DispensingLanguage[lan][menukey]["Date"]}
                  value={allergyData.date || new Date()}
                  inputFormat="dd/MM/yyyy"
                  onChange={(e) =>
                    handleRDateChangeByTabs(e, "date", "allergyData")
                  }
                  renderInput={(params) => (
                    <TextField {...params} variant="standard" />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                variant="standard"
                required
                error={!!errorAllergiesData.allergyTitle}
                helperText={errorAllergiesData.allergyTitle}
                id="allergyTitle"
                name="allergyTitle"
                label={DispensingLanguage[lan][menukey]["Allergy"]}
                value={allergyData.allergyTitle ?? ""}
                fullWidth
                autoComplete="family-name"
                onChange={(e) => handleChangeByTabs(e, "allergyData")}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                variant="standard"
                id="description"
                name="description"
                label={DispensingLanguage[lan][menukey]["Description"]}
                value={allergyData.description ?? ""}
                fullWidth
                autoComplete="family-name"
                onChange={(e) => handleChangeByTabs(e, "allergyData")}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="standard"
                id="source"
                name="source"
                label={DispensingLanguage[lan][menukey]["Source"]}
                value={allergyData.source ?? ""}
                fullWidth
                autoComplete="family-name"
                onChange={(e) => handleChangeByTabs(e, "allergyData")}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            className="float-start"
            variant="contained"
            color="gray"
            onClick={handleClose}
          >
            {DispensingLanguage[lan][menukey]["Cancel"]}
          </Button>
          <Button
            autoFocus
            className="me-2 float-start"
            variant="contained"
            color="primary"
            onClick={() => handleSubmitByTabs("allergyData")}
          >
            {DispensingLanguage[lan][menukey]["Save changes"]}
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </>
  );
};

export default AllergiesTab;
